import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useResponsive } from '@/composables';

// Props interface con type safety e nuove props opzionali
interface Props {
	pageSize?: number;
	total?: number;
	currentPage?: number;
	pageSizes?: number[];
	// Nuove props opzionali per responsive e styling
	showBackground?: boolean; // Element UI background styling
	compactOnMobile?: boolean; // Layout responsive automatico
}

// Props con defaults per backward compatibility totale

export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    pageSize: { default: 25 },
    total: { default: 1000 },
    currentPage: { default: 1 },
    pageSizes: { default: () => [10, 25, 50, 100] },
    showBackground: { type: Boolean, default: false },
    compactOnMobile: { type: Boolean, default: true }
  },
  emits: ['size-change', 'current-change'],
  setup(__props: any, { emit }) {

const props = __props as { pageSize: number, total: number, currentPage: number, pageSizes: number[], showBackground: boolean, compactOnMobile: boolean };



// Composable responsive centralizzato - condiviso con tutto il sistema
const { showOnlyXs, showOnlySm, showOnlyMd } = useResponsive();

// Layout responsive computed - il cuore della funzionalità
const responsiveLayout = computed(() => {
	if (!props.compactOnMobile) {
		return 'total, sizes, prev, pager, next'; // Layout fisso originale per backward compatibility
	}

	// Layout responsivo quando compactOnMobile è true
	if (showOnlyXs.value) {
		return 'prev, next'; // Solo navigazione su mobile
	}
	if (showOnlySm.value) {
		return 'prev, pager, next'; // Aggiungi paginatore
	}
	if (showOnlyMd.value) {
		return 'total, prev, pager, next'; // Aggiungi totale
	}
	// lg e superiori
	return 'total, sizes, prev, pager, next'; // Layout completo
});

// Nota: Lifecycle hooks e gestione resize ora gestiti dal composable useResponsive

// Events tipizzati - signature identica per zero breaking changes


// Event handlers con type safety
function handleSizeChange(val: number): void {
	emit('size-change', val);
}

function handleCurrentChange(val: number): void {
	emit('current-change', val);
}

return { __sfc: true,props, showOnlyXs, showOnlySm, showOnlyMd, responsiveLayout, emit, handleSizeChange, handleCurrentChange }
}

})